import React, { useState } from "react";
import { InputGroup, InputLeftElement, Input, Button } from "@chakra-ui/react";
import { SearchIcon } from "../Icons/SearchIcon";

export const Search = ({
  placeholder,
  searchName,
  searchTextCallback,
  ...props
}) => {
  const [searchInput, setSearchInput] = useState("");


  const handleSearch = (event) => {
    setSearchInput(event.target.value);
    if(event.target.value === "") {
      searchTextCallback("")
    }
  };

  return (
    <InputGroup {...props} mb="15">
      <InputLeftElement pointerEvents="none" children={<SearchIcon />} />
      <Input
        type="text"
        placeholder={placeholder}
        value={searchInput}
        onChange={handleSearch}
        background="aliceblue"
      />
      <Button ml={2} onClick={() => searchTextCallback(!!searchInput ? searchInput : "")} color="blue.500">Search</Button>
    </InputGroup>
  );
};
